import React from 'react';
import { motion } from 'framer-motion';
import './Investors.css';

const Investors = () => {
  const fadeInUp = {
    initial: { opacity: 0, y: 30 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 }
  };

  const metrics = [
    { label: 'CAGR', value: '45%', description: 'Compound Annual Growth Rate' },
    { label: 'WTP', value: '₹120/L', description: 'Willingness to Pay Premium' },
    { label: 'ESG Score', value: 'A+', description: 'Environmental, Social, Governance' },
    { label: 'Market Share', value: '2.5%', description: 'Premium Dairy Segment' }
  ];

  const esgPillars = [
    {
      title: 'Environmental',
      icon: '🌱',
      points: [
        '70% energy from biogas',
        '100% self-grown feed',
        '95% waste recycled',
        '30% water saved'
      ]
    },
    {
      title: 'Social',
      icon: '🤝',
      points: [
        'Fair wages for farm workers',
        'Community health programs',
        'Educational initiatives',
        'Local employment generation'
      ]
    },
    {
      title: 'Governance',
      icon: '📋',
      points: [
        'Transparent operations',
        'Ethical animal treatment',
        'Regulatory compliance',
        'Stakeholder accountability'
      ]
    }
  ];

  return (
    <div className="investors-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-background parallax-container">
          <div className="parallax-bg" style={{
            backgroundImage: 'linear-gradient(rgba(11, 19, 43, 0.7), rgba(11, 19, 43, 0.8)), url(https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1920)',
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}></div>
        </div>
        <div className="container hero-content">
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="hero-headline"
          >
            Investor Vision
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="hero-subheadline"
          >
            Building a sustainable, profitable, and ethical dairy enterprise for the future.
          </motion.p>
        </div>
      </section>

      {/* Metrics Section */}
      <section className="section metrics-section">
        <div className="container">
          <motion.h2
            initial="initial"
            whileInView="animate"
            viewport={{ once: true }}
            variants={fadeInUp}
            className="section-title"
          >
            Key Metrics
          </motion.h2>
          <div className="metrics-grid">
            {metrics.map((metric, index) => (
              <motion.div
                key={metric.label}
                initial="initial"
                whileInView="animate"
                viewport={{ once: true }}
                variants={fadeInUp}
                transition={{ delay: index * 0.1 }}
                className="metric-card card card-gold"
              >
                <div className="metric-value">{metric.value}</div>
                <div className="metric-label">{metric.label}</div>
                <div className="metric-description">{metric.description}</div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ESG Pillars */}
      <section className="section esg-section">
        <div className="container">
          <motion.h2
            initial="initial"
            whileInView="animate"
            viewport={{ once: true }}
            variants={fadeInUp}
            className="section-title"
          >
            ESG Pillars
          </motion.h2>
          <div className="esg-grid">
            {esgPillars.map((pillar, index) => (
              <motion.div
                key={pillar.title}
                initial="initial"
                whileInView="animate"
                viewport={{ once: true }}
                variants={fadeInUp}
                transition={{ delay: index * 0.2 }}
                className="esg-card card card-gold"
              >
                <div className="esg-icon">{pillar.icon}</div>
                <h3>{pillar.title}</h3>
                <ul className="esg-points">
                  {pillar.points.map((point, i) => (
                    <li key={i}>{point}</li>
                  ))}
                </ul>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Investor Deck CTA */}
      <section className="section deck-section">
        <div className="container">
          <motion.div
            initial="initial"
            whileInView="animate"
            viewport={{ once: true }}
            variants={fadeInUp}
            className="deck-cta"
          >
            <h2>Download Investor Deck</h2>
            <p>Get comprehensive insights into our business model, financial projections, and growth strategy.</p>
            <button className="btn btn-primary">Download PDF</button>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Investors;

